import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Check from "../../assets/img/check.svg";
import card from "../../assets/img/card-vegzelma.png";
import cardyuflyma from "../../assets/img/card-yuflyma.svg";
import cardzymfentra from "../../assets/img/card-zymfentra-group.png";
import cardadalimumab from "../../assets/img/card-adalimumab.png";
import cardsteqeyma from "../../assets/img/card-steqeyma.png";
import cardstoboclo from "../../assets/img/card-stoboclo.png";
import cardosenvelt from "../../assets/img/card-osenvelt.png";
import cardavtozma from "../../assets/img/card-avtozma.png";
// NOTE: FPO card art from the Figma comp - swap when the final OMLYCLO card is approved
import cardomlyclo from "../../assets/img/card-omlyclo.png";
import {
  Link,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import yuflymaLogo from "../../assets/img/yuflyma-logo.png";
import adalimumabLogo from "../../assets/img/Adalimumab-aaty_logo.png";
import CelltrionCare from "../popup/celltrionCare";
import {
  getProductColor,
  getProductName,
  getProductButtonColor,
} from "../../utilities/productColor";

const SubmittedForm = ({ data }) => {
  const [role, setRole] = useState("");
  const [searchParams] = useSearchParams();
  const { category } = useParams();
  const location = useLocation();
  const isZymfentra = location?.pathname.includes("zymfentra");

  const [modalShow, setModalShow] = useState(false);

  let cardID = data && data?.cardID ? data?.cardID[0] : data?.member_id;

  const passedRole = searchParams.get("role");
  const defaultRole = passedRole ?? "patient";
  const roleName = defaultRole.charAt(0).toUpperCase() + defaultRole.slice(1);

  localStorage.setItem("cardID", cardID);
  if (data?.BIN && data?.PCN && data?.GROUP) {
    localStorage.setItem("rxBin", data.BIN);
    localStorage.setItem("rxGroup", data.GROUP);
    localStorage.setItem("rxPcn", data.PCN);
  }
  localStorage.setItem("roleName", roleName);

  useEffect(() => {
    const passedRole = searchParams.get("role");
    if (passedRole) {
      setRole(passedRole);
    }
  }, [role, searchParams]);

  let spanClass =
    category === "adalimumab"
      ? "rselection roles-section3"
      : "rselection roles-section2 steqeyma-submitted";

  const categoryCardClasses = {
    yuflyma: "spanYuflyma",
    zymfentra: "spanZymfentra",
    adalimumab: "spanAdalimumab",
    vegzelma: "spanVegzelma",
    steqeyma: "spanSteqeyma",
    osenvelt: "spanOsenvelt",
    stoboclo: "spanStoboclo",
    avtozma: "spanAvtozma",
    omlyclo: "spanOmlyclo",
  };

  const categoryCard = {
    zymfentra: cardzymfentra,
    steqeyma: cardsteqeyma,
    osenvelt: cardosenvelt,
    stoboclo: cardstoboclo,
    avtozma: cardavtozma,
    omlyclo: cardomlyclo,
    adalimumab: cardadalimumab,
    vegzelma: card,
  };

  const productName = getProductName(location.pathname);

  const productColor = getProductColor(location.pathname);

  const productButtonColor = getProductButtonColor(location.pathname);

  // Figma renders the AM/PM meridiems slightly smaller than the hour.
  const meridiem = { fontSize: "0.8em", textTransform: "uppercase" };

  // Figma "1.2.3 Enroll Now Step 3" puts the claim-adjudication heading inside
  // a tinted panel with its content, below (not including) DOWNLOAD DETAILS.
  // Scoped to OMLYCLO: every other product keeps the heading where it was.
  // Products whose member-ID overlay has been re-based on .card-fixed - the
  // card's own box - instead of the column, which `d-block` stretches to full
  // width. Add a product here once its span percentages have been re-measured
  // against its card art.
  const FIXED_CARD_PRODUCTS = [
    "omlyclo",
    "avtozma",
    "stoboclo",
    "osenvelt",
    "steqeyma",
  ];
  const cardFixedClass = FIXED_CARD_PRODUCTS.includes(category)
    ? ` card-fixed card-fixed--${category}`
    : "";
  const isOmlyclo = category === "omlyclo";
  const claimHeading = (
    <Button
      style={{ color: productColor }}
      className={
        isZymfentra
          ? "theme-button theme-button-text zymfentra-purple fw-medium instructions-heading-2"
          : "theme-button theme-button-text secondary-color fw-medium instructions-heading-2"
      }
    >
      MEDICAL BENEFIT CO-PAY CLAIM ADJUDICATION:
    </Button>
  );

  return (
    <>
      {category === "osenvelt" ||
      category === "stoboclo" ||
      category === "steqeyma" ||
      category === "avtozma" ||
      category === "omlyclo" ||
      category === "zymfentra" ||
      category === "adalimumab" ||
      category === "vegzelma" ? (
        <section className={spanClass}>
          {category === "yuflyma" ? (
            <img src={yuflymaLogo} className="bevacizumab" alt="yuflyma" />
          ) : category === "adalimumab" ? (
            <img
              src={adalimumabLogo}
              className="bevacizumab"
              alt="adalimumab-aaty"
            />
          ) : null}
          <Container>
            <Row className="justify-content-center">
              <Col
                lg={8}
                xl={
                  isOmlyclo
                    ? 12
                    : location.pathname === "/inquiry-form/steqeyma" ||
                      location.pathname === "/inquiry-form/zymfentra"
                    ? 9
                    : 6
                }
              >
                <div
                  className={`rselection-wrap role-wrap firstCard ${
                    isOmlyclo ? "omlyclo-page-card " : ""
                  }${
                    category === "steqeyma" ? "steqeyma-card" : "zymfentra-card"
                  }`}
                >
                  <div className="heads-icon">
                    <div className="hi-icon steqeyma-check-icon">
                      <img src={Check} alt="" />
                    </div>
                    <div className="all-set">
                      <p className="mainText mt1">You’re all set!</p>
                    </div>
                  </div>
                  <div>
                    <p className="fw-medium-1 mt2">
                      Congratulations! Your enrollment in the Celltrion CARES
                      <sup className="reg">&reg;</sup> Co&#8209;pay Assistance
                      Program is complete!
                    </p>
                    <p className="text-center title-saving font-16 fw-medium mt-5">
                      Co-pay Savings Card Information
                    </p>
                    <div
                      className={`card-wrapper d-block${cardFixedClass}`}
                      style={{ border: "1px" }}
                    >
                      <img src={categoryCard[category]} alt="card" />
                      <span className={categoryCardClasses[category] || ""}>
                        {cardID}
                      </span>
                      {/* {category === "zymfentra" && (
                        <>
                          <span className="binZymfentra">{data?.BIN}</span>
                          <span className="pcnZymfentra">{data?.PCN}</span>
                          <span className="groupZymfentra">{data?.GROUP}</span>
                        </>
                      )} */}
                    </div>
                    <div className="button-holders">
                      <Link
                        to={`/${
                          role === "prescriber" ? "download-pdf" : "pharma-pdf"
                        }/${category}?downloadPDF=true`}
                        target="_blank"
                        className={
                          isZymfentra
                            ? "theme-btn theme-button zymfentra-purple"
                            : "theme-btn theme-button theme-button-primary"
                        }
                        style={{ backgroundColor: productButtonColor }}
                      >
                        DOWNLOAD DETAILS
                      </Link>
                      {/* <Button className="theme-button theme-button-text secondary-color fw-medium instructions-heading-1">
                        INSTRUCTIONS FOR USE
                      </Button> */}
                      {!isOmlyclo && claimHeading}
                    </div>
                  </div>
                  <div className="font-14">
                    <Container
                      style={isOmlyclo ? undefined : { paddingRight: "40px" }}
                    >
                      <div className={isOmlyclo ? "claims-panel" : undefined}>
                      {isOmlyclo && (
                        <div className="button-holders">{claimHeading}</div>
                      )}
                      <p>
                        If you are a doctor's office, print this copay card and
                        make sure you include it in the patient's chart.
                      </p>
                      <p>
                        Once you have received the primary Explanation of
                        Benefits (EOB) from the insurance provider, please
                        follow the steps listed below for submitting
                        claims:{" "}
                      </p>
                      <p>
                        Either the patient or the healthcare provider (HCP)
                        should submit the following documents via fax to
                        877-431-6444.
                      </p>
                      <ul>
                        <li>
                          For the first claim submission for your patient,
                          include the Provider Payment Form found{" "}
                          <a
                            href="/files/Provider_Payment_Form.pdf"
                            target="_blank"
                            rel="noreferrer"
                          >
                            here
                          </a>
                          .
                        </li>
                        <li>
                          Completed claim form (Universal, UB or CMS-1500 Claim
                          Form).
                        </li>
                        <li>
                          Primary Explanation of Benefits (EOB) showing itemized
                          claim from the patient's private insurance company
                          with the cost for each NDC listed separately.
                        </li>
                      </ul>
                      <p>
                        Your office will receive reimbursement of the patient's
                        applicable co-pay or coinsurance as determined by the
                        Program Terms and Conditions.
                      </p>
                      <p>
                        Once all information has been received and validated,
                        please allow 7-10 business days to receive payment. The
                        provider's office will collect patient out-of-pocket
                        responsibility, based on the patient's insurance
                        coverage. The provider is responsible for the collection
                        of the remaining balance from the patient.
                      </p>
                      <p>
                        Please note: You must submit the claim for reimbursement
                        to the Patient Support Program within 180 days of the
                        date listed on the EOB from the patient's primary
                        insurance company.
                      </p>
                      </div>

                      <div>
                        <div className="button-holders">
                          <Button
                            style={{ color: productColor }}
                            className={
                              isZymfentra
                                ? "theme-button theme-button-text zymfentra-purple fw-medium instructions-heading-2"
                                : "theme-button theme-button-text secondary-color fw-medium instructions-heading-2"
                            }
                          >
                            PHARMACY CLAIMS PROCESSING:
                          </Button>
                        </div>
                        <p>
                          When you use this card, you are certifying that you
                          have not submitted and will not submit a claim for
                          reimbursement under any federal, state or other
                          governmental programs for this prescription.
                        </p>
                        <ul>
                          <li>
                            Submit transaction to Paysign using{" "}
                            <strong> BIN #610020</strong>
                          </li>
                          <li>
                            If primary commercial prescription insurance exists,
                            input card information as secondary coverage and
                            transmit using the COB segment of the NCPDP
                            transaction. Applicable discounts will be displayed
                            in the transaction response.
                          </li>
                          <li>
                            Acceptance of this card and your submission of
                            claims for the Co-pay Program are subject to the
                            Celltrion CARES<sup className="reg">&reg;</sup>{" "}
                            Co-pay Assistance Program{" "}
                            <a
                              href="#"
                              onClick={() => setModalShow(true)}
                              style={{
                                color: "#652E6C",
                                textDecoration: "underline",
                              }}
                            >
                              Terms and Conditions
                            </a>
                            .
                          </li>
                          <li>
                            The Patient is not eligible if prescriptions are
                            paid in part or full by any state or federally
                            funded programs, including but not limited to
                            Medicare or Medicaid, Medigap, VA, DOD, TRICARE, or
                            where prohibited by law.
                          </li>
                          <li>
                            The Celltrion CARES<sup className="reg">&reg;</sup>{" "}
                            Co-pay card is not valid for use with any other
                            prescription drug discount or cash cards. Claims
                            submitted utilizing the program are subject to
                            audit or validation.
                          </li>
                          <p>
                            For questions regarding setup, claim transmission,
                            patient eligibility or other issues, call the
                            Celltrion CARES
                            <sup>&reg;</sup> Co-pay Assistance Program at{" "}
                            <span className="fw-medium">877-812-6662</span>, 8 <span style={meridiem}>AM</span>-8 <span style={meridiem}>PM</span> ET, Monday - Friday.
                          </p>
                        </ul>
                      </div>
                    </Container>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      ) : (
        <section className={spanClass}>
          <Container>
            <Row className="justify-content-center">
              <Col lg={8} xl={6}>
                <div className="rselection-wrap role-wrap firstCard">
                  <div className="heads-icon">
                    <div className="hi-icon me-4">
                      <img src={Check} />
                    </div>
                    <div className="all-set">
                      <p className="mainText mt1">{roleName} Enrollment</p>
                      <p className="mainText mt1">You’re all set!</p>
                      <p className="fw-medium mt2">
                        Congratulations! Your enrollment in the Celltrion CARES
                        <sup className="reg">&reg;</sup> Co-pay Assistance
                        Program is complete!
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="text-center title-saving font-16 fw-medium">
                      Co-pay Savings Card Information
                    </p>
                    <div
                      className="card-wrapper d-block"
                      style={{ border: "1px" }}
                    >
                      {category === "yuflyma" ? (
                        <img src={cardyuflyma} alt="card" />
                      ) : category === "vegzelma" ? (
                        <img src={card} alt="card" />
                      ) : category === "zymfentra" ? (
                        <img src={cardzymfentra} alt="card" />
                      ) : category === "adalimumab" ? (
                        <img src={cardadalimumab} alt="card" />
                      ) : null}
                      <span
                        style={{ border: "1px" }}
                        className={
                          category === "yuflyma"
                            ? "spanYuflyma"
                            : category === "zymfentra"
                              ? "spanZymfentra"
                              : category === "adalimumab"
                                ? "spanAdalimumab"
                                : category === "vegzelma"
                                  ? "spanVegzelma"
                                  : ""
                        }
                      >
                        {cardID}
                      </span>
                      {/* {category === "zymfentra" && (
                        <>
                          <span className="binZymfentra">{data?.BIN}</span>
                          <span className="pcnZymfentra">{data?.PCN}</span>
                          <span className="groupZymfentra">{data?.GROUP}</span>
                        </>
                      )} */}
                    </div>
                    <div className="button-holders">
                      <Link
                        to={`/${
                          role === "prescriber" ? "download-pdf" : "pharma-pdf"
                        }/${category}?downloadPDF=true`}
                        target="_blank"
                        className={
                          isZymfentra
                            ? "theme-btn theme-button zymfentra-purple"
                            : "theme-btn theme-button theme-button-primary"
                        }
                      >
                        DOWNLOAD DETAILS
                      </Link>
                      <Button className="theme-button theme-button-text secondary-color fw-medium">
                        INSTRUCTIONS FOR USE
                      </Button>
                    </div>
                  </div>

                  {role === "prescriber" && category !== "adalimumab" ? (
                    <div className="font-14">
                      <p className="font-16 fw-medium">
                        {" "}
                        MEDICAL BENEFIT CO-PAY CLAIM ADJUDICATION:
                      </p>
                      <p>
                        Once you have received the primary Explanation of
                        Benefits (EOB) from your patient’s insurance provider,
                        please follow the steps listed below for submitting
                        claims:
                      </p>
                      <p>
                        {category === "zymfentra" && (
                          <>
                            {" "}
                            Please submit the following documents via fax to{" "}
                            <strong>
                              <a href="tel:1-877-431-6444">877-431-6444</a>
                            </strong>
                          </>
                        )}
                        {category !== "zymfentra" && (
                          <>
                            {" "}
                            Please submit the following documents via fax to{" "}
                            <a href="tel:1-844-806-1719">844-806-1719</a> or the
                            following website:{" "}
                            <a href="#">https://copayhelp.mckesson.com</a>
                          </>
                        )}
                      </p>
                      <ul>
                        <li>
                          Completed claim form (Universal, UB-04 or CMS-1500
                          Claim Form).
                        </li>
                        <li>
                          Primary Explanation of Benefits (EOB) showing itemized
                          claim from the patient’s private insurance company
                          with the cost for each NDC listed separately.
                        </li>
                      </ul>
                      <p>
                        Your office will receive reimbursement of the patient’s
                        applicable copay or coinsurance as determined by the
                        Program Terms and Conditions. Please allow 7-10 business
                        days for receipt of payment. Your office will collect
                        patient out-of-pocket responsibility, based on the
                        program benefit design. You are responsible for
                      </p>
                      <p className="font-16 fw-medium">
                        PHARMACY CLAIMS PROCESSING:
                      </p>
                      <p>
                        {" "}
                        When you use this card, you are certifying that you have
                        not submitted and will not submit a claim for
                        reimbursement under any federal, state or other
                        governmental programs for this prescription.
                      </p>

                      <ul>
                        {category === "zymfentra" && (
                          <>
                            <li>
                              Submit transaction to Paysign using{" "}
                              <strong>BIN #610020</strong>
                            </li>
                            <li>
                              If primary commercial prescription insurance
                              exists, input card information as secondary
                              coverage and transmit using the COB segment of the
                              NCPDP transaction. Applicable discounts will be
                              displayed in the transaction response.
                            </li>
                            <li>
                              Acceptance of this card and your submission of
                              claims for the Co-pay Program are subject to the
                              Celltrion CARES
                              <sup>&reg;</sup> Co&#8209;pay Assistance Program
                              Terms and Conditions posted at{" "}
                              <a
                                href="https://www.celltrionconnect.com/terms-of-use/"
                                target="_blank"
                                rel="noreferrer"
                              >
                                celltrionconnect.com/terms-of-use/
                              </a>
                            </li>
                          </>
                        )}
                        {category !== "zymfentra" && (
                          <>
                            <li>Submit transaction to BIN #610524</li>
                            <li>
                              If primary commercial prescription insurance
                              exists, input card information as secondary
                              coverage and transmit using the Coordination of
                              Benefits (COB) segment of the National Council for
                              Prescription Drug Programs (NCPDP) transaction.
                              Applicable discounts will be displayed in the
                              transaction response.
                            </li>
                            <li>
                              Acceptance of this card and your submission of
                              claims for the Co&#8209;pay Program are subject to
                              the Celltrion CARES
                              <sup>&reg;</sup> Co&#8209;pay Assistance Program
                              Terms and Conditions posted at{" "}
                              <a
                                href="https://www.mckesson.com/mprstnc"
                                target="_blank"
                                rel="noreferrer"
                              >
                                www.mckesson.com/mprstnc
                              </a>
                            </li>
                          </>
                        )}
                        <li>
                          The Patient is not eligible if prescriptions are paid
                          in part or full by any state or federally funded
                          programs, including but not limited to Medicare or
                          Medicaid, Medigap, VA, DOD, TRICARE, or where
                          prohibited by law.
                        </li>
                        <li>
                          The Celltrion CARES<sup>&reg;</sup> Co-pay card is not
                          valid for use with any other prescription drug
                          discount or cash cards. Claims submitted utilizing the
                          program are subject to audit or validation.
                        </li>
                      </ul>
                      <p>
                        For questions regarding setup, claim transmission,
                        patient eligibility or other issues, call the Celltrion
                        CARES
                        <sup>&reg;</sup> Co-pay Assistance Program at{" "}
                        <span className="fw-medium">877-812-6662</span>, 8 <span style={meridiem}>AM</span>-8 <span style={meridiem}>PM</span> ET, Monday - Friday.
                      </p>
                    </div>
                  ) : (
                    <div className="font-14">
                      <p className="font-16 fw-medium">
                        {" "}
                        PHARMACY CLAIMS PROCESSING:
                      </p>
                      <p>
                        When you use this card, you are certifying that you have
                        not submitted and will not submit a claim for
                        reimbursement under any federal, state or other
                        governmental programs for this prescription.
                      </p>
                      <ul>
                        {category === "zymfentra" && (
                          <>
                            <li>
                              Submit transaction to Paysign using{" "}
                              <strong>BIN #610020</strong>
                            </li>
                            <li>
                              If primary commercial prescription insurance
                              exists, input card information as secondary
                              coverage and transmit using the COB segment of the
                              NCPDP transaction. Applicable discounts will be
                              displayed in the transaction response.
                            </li>
                            <li>
                              Acceptance of this card and your submission of
                              claims for the Co-pay Program are subject to the
                              Celltrion CARES
                              <sup>&reg;</sup> Co-pay Assistance Program Terms
                              and Conditions posted at{" "}
                              <a
                                href="https://www.celltrionconnect.com/terms-of-use/"
                                target="_blank"
                                rel="noreferrer"
                              >
                                celltrionconnect.com/terms-of-use/
                              </a>
                            </li>
                          </>
                        )}
                        {category !== "zymfentra" && (
                          <>
                            <li>Submit transaction to BIN #610524</li>
                            <li>
                              If primary commercial prescription insurance
                              exists, input card information as secondary
                              coverage and transmit using the Coordination of
                              Benefits (COB) segment of the National Council for
                              Prescription Drug Programs (NCPDP) transaction.
                              Applicable discounts will be displayed in the
                              transaction response.
                            </li>
                            <li>
                              Acceptance of this card and your submission of
                              claims for the Co-pay Program are subject to the
                              Celltrion CARES
                              <sup>&reg;</sup> Co-pay Assistance Program Terms
                              and Conditions posted at{" "}
                              <a
                                href="https://www.mckesson.com/mprstnc"
                                target="_blank"
                                rel="noreferrer"
                              >
                                www.mckesson.com/mprstnc
                              </a>
                            </li>
                          </>
                        )}
                        <li>
                          The Patient is not eligible if prescriptions are paid
                          in part or full by any state or federally funded
                          programs, including but not limited to Medicare or
                          Medicaid, Medigap, VA, DOD, TRICARE, or where
                          prohibited by law.
                        </li>
                        <li>
                          The Celltrion CARES<sup>&reg;</sup> Co-pay card is not
                          valid for use with any other prescription drug
                          discount or cash cards. Claims submitted utilizing the
                          program are subject to audit or validation.
                        </li>
                      </ul>

                      <p>
                        For questions regarding setup, claim transmission,
                        patient eligibility or other issues, call the Celltrion
                        CARES
                        <sup>&reg;</sup> Co-pay Assistance Program at{" "}
                        <span className="fw-medium">
                          <br></br>1-877-812-6662
                        </span>
                        , 8 <span style={meridiem}>AM</span>-8 <span style={meridiem}>PM</span> ET, Monday - Friday.
                      </p>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      )}

      <CelltrionCare show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
};

export default SubmittedForm;
